import {urls} from 'src/config';

export async function crearCodigoValidacionApi(email) {
   try {
      const response = await fetch(`${urls.backEnd}/crearCodigoValidacion`, {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json'
         },
         body: JSON.stringify({email})
      });
      if (!response.ok) {
         const errorText = await response.text();
         const errorTranslated = new Error(errorText);
         const errorJson = JSON.parse(errorTranslated.message);
         return {data: null, error: errorJson['error']};
      }

      const data = await response.json();
      return {data, error: null};
   } catch (err) {
      return {data: null, error: err};
   }
}

export async function recuperarCuentaApi(email, codigo) {
   try {
      const response = await fetch(`${urls.backEnd}/recuperarCuenta`, {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json'
         },
         body: JSON.stringify({email, codigo})
      });

      if (!response.ok) {
         const errorText = await response.text();
         const errorTranslated = new Error(errorText);
         const errorJson = JSON.parse(errorTranslated.message);
         return {data: null, error: errorJson['error']};
      }

      const data = await response.json();
      return {data, error: null};
   } catch (err) {
      return {data: null, error: err};
   }
}
